import React, { useState } from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  ListSubheader,
  useMediaQuery
} from "@material-ui/core";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { UserEventsProps } from "./types";
import { UserEvent } from "./UserEvent";
import { useTheme } from "@material-ui/core/styles";
import useModuleStyles from "../../styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import { UserOverview } from "../../../users/UserOverview";
import { InclVat } from "../inclVat";

export const UserEvents = (userEvents: UserEventsProps) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const moduleClasses = useModuleStyles();

  const [userId, setUserId] = useState("");

  return (
    <>
      <Box display="block" position="relative">
        <List
          component="nav"
          subheader={
            <ListSubheader
              component="div"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <Typography
                color="textPrimary"
                variant="button"
                style={{ paddingTop: 7, paddingBottom: 7 }}
              >
                Visitors
              </Typography>
              <InclVat />
            </ListSubheader>
          }
        >
          <Divider style={{ marginBottom: "1rem" }} />

          {userEvents.events.map((event, i) => {
            return (
              <UserEvent
                {...event}
                key={i}
                onClick={userId => setUserId(userId)}
              />
            );
          })}
        </List>
        {!userEvents.isLoading ? (
          <></>
        ) : (
          <div className={moduleClasses.spinnerContainer}>
            <CircularProgress />
          </div>
        )}
      </Box>

      <Dialog
        onClose={() => setUserId("")}
        open={userId !== ""}
        fullWidth={true}
        fullScreen={mobile}
        maxWidth={"xl"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <MuiDialogTitle style={{ height: 50 }} disableTypography>
          <IconButton
            aria-label="close"
            className={moduleClasses.closeButton}
            onClick={() => setUserId("")}
          >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <DialogContent style={mobile ? { padding: 0 } : {}}>
          <UserOverview inputUserId={userId} />
        </DialogContent>
      </Dialog>
    </>
  );
};
